// extracted by mini-css-extract-plugin
export default {"container":"breadcrumbs_container__40Nxl"};